export default "__VITE_ASSET__Be317Y_V__$_?nuxt_component=async&nuxt_component_name=SvgoRuFlag&nuxt_component_export=default__"